import { DataType, IValidationError } from 'flux-definition';
import { AbstractDataItem } from './data-item-abstract';

/**
 * Data item class for the IMAGE data type. Data items in shape models with the IMAGE
 * data type will be deserialized into instances of this class by the `DataItemFactory`.
 */
export class ImageDataItem extends AbstractDataItem<DataType.IMAGE> {
    /**
     * Checks whether the given value is valid (returns the error if any)
     */
    public validate( value: typeof ImageDataItem.prototype.value ): IValidationError {
        if ( value === undefined ) {
            return null;
        }
        if ( typeof value === 'string' ) {
            // TODO: check whether the string value is a valid image url
            return null;
        }
        return { message: `"${value}" is not a valid image url or drawable` };
    }
}
